export default __webpack_public_path__ + "static/media/linkedin.080ec09e.svg";